module.exports = __webpack_public_path__ + "static/media/Thomas Jefferson - 1796.50af9b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Thomas Jefferson - 1796.jpg
// module id = 554
// module chunks = 0